/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InputPlain/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function InputPlain({
  children,
  viewPath = "/DesignSystem/InputPlain",
  borderBottomLeftRadius = 8,
  borderBottomRightRadius = 8,
  borderTopLeftRadius = 8,
  borderTopRightRadius = 8,
  autoComplete = "on",
  autoCapitalize,
  autoFocus,
  className,
  disabled,
  fontFamily = "Inter",
  fontSize = 16,
  onBlur,
  onChange,
  onFocus,
  onKeyUp,
  marginRight = 0,
  marginLeft = 0,
  marginTop = 0,
  marginBottom = 0,
  paddingBottom = 16,
  paddingLeft = 16,
  paddingRight = 16,
  paddingTop = 16,
  placeholder,
  innerRef,
  textTransform = "none",
  type = "text",
  textAlign = "left",
  value,
  width = 200,
  height = "auto"
  
}) {
  return (<React.Fragment
>
<input
 type={
                type === 'phone' ? 'tel' :
                type === 'secure' ? 'password' : type}
inputMode={type === 'number' || type === 'phone'? "numeric" : undefined}
pattern={type === 'number' || type === 'phone'? "[0-9]*" : undefined}
  data-testid="InputPlain.Input"
  data-view-path={viewPath}
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 disabled={disabled}
 onBlur={onBlur}
 onChange={(e) => onChange && onChange(e, e.target.value)}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 placeholder={placeholder}
 ref={innerRef}
 value={value}
 style={{'--bblr-1-Z165vNg': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-2-Z165vNg': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-3-Z165vNg': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-4-Z165vNg': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--ff-5-Z165vNg': fontFamily,'--fs-6-Z165vNg': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--mr-7-Z165vNg': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-8-Z165vNg': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mt-9-Z165vNg': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-10-Z165vNg': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--pb-11-Z165vNg': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-12-Z165vNg': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-13-Z165vNg': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-14-Z165vNg': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--tt-15-Z165vNg': textTransform,'--ta-16-Z165vNg': textAlign,'--w-17-Z165vNg': typeof width === 'number' ? `${width}px` : width,'--h-18-Z165vNg': typeof height === 'number' ? `${height}px` : height}}
 className={`views-capture ${className} ${styles.Input}`}
/>
{children}
</React.Fragment>)
}